import type {
    CommerceCatalogueExperience,
    CommerceProductIdentity,
    SearchCommerceProductsRequest,
} from "@teqtank/commerce-contracts";

export function createProductSearchCacheKey(request: SearchCommerceProductsRequest): string {
    return `products:search:${stableSerialize(request)}`;
}

export function createProductCacheKey(
    identifier: string,
    identity: CommerceProductIdentity,
    experience: CommerceCatalogueExperience,
    catalogueId?: string,
): string {
    return `products:item:${experience}:${catalogueId ?? "default"}:${identity}:${identifier}`;
}

export function createProductCategoryCacheKey(
    categoryId: string,
    experience: CommerceCatalogueExperience,
    catalogueId?: string,
): string {
    return `products:category:${experience}:${catalogueId ?? "default"}:${categoryId}`;
}

export function createProductCategoriesCacheKey(
    parentId: string | null | undefined,
    experience: CommerceCatalogueExperience,
    catalogueId?: string,
): string {
    return `products:categories:${experience}:${catalogueId ?? "default"}:${parentId ?? "all"}`;
}

function stableSerialize(value: unknown): string {
    if (value === null || typeof value !== "object") {
        return JSON.stringify(value);
    }

    if (Array.isArray(value)) {
        return `[${value.map(stableSerialize).join(",")}]`;
    }

    const record = value as Record<string, unknown>;
    const properties = Object.keys(record)
        .sort()
        .filter((key) => record[key] !== undefined)
        .map((key) => `${JSON.stringify(key)}:${stableSerialize(record[key])}`);

    return `{${properties.join(",")}}`;
}
